import { ValidationError } from "@common/types";
import { WorkspaceReadModel } from "@Organizations/Workspaces/readmodels";

export class PortfolioCreatorDialogViewModel
{
    opened: boolean = false;

    name: string | null = null;
    description: string | null = null;
    workspaceId: number | null = null;

    workspaces: WorkspaceReadModel[] = [];

    errors: ValidationError[] = [];

    show(workspaceId: number, name: string, workspaces: WorkspaceReadModel[])
    {
        this.workspaceId = workspaceId;
        this.name = name;
        this.description = null;

        this.workspaces = workspaces;

        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.workspaceId = null;
        this.name = null;
        this.description = null;

        this.workspaces = [];

        this.clearValidationErrors();
    }

    clearValidationErrors()
    {
        this.errors = [];
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.errors = errors;
    }

}

export class CreatePortfolioEventPayload
{
    portfolioWorkspaceId: number;
    portfolioName: string;
    portfolioDescription: string;

    constructor(workspaceId: number, portfolioName: string, portfolioDescription: string)
    {
        this.portfolioWorkspaceId = workspaceId;
        this.portfolioName = portfolioName;
        this.portfolioDescription = portfolioDescription;
    }
}